import { useQuery } from 'react-query';
// configs
import { API } from 'configs/api';
import { TranslationData, TranslationQueryParams } from './types';
import { videoKeys } from './videoKeys';

export const getTranslationInfo = async (
  videoId: number,
  userId: number,
  language: string
) => {
  const { data } = await API.get('/transcripts', {
    params: { language, userId, videoId },
  });
  return data;
};

export const useGetTranslationInfoQuery = ({
  videoId,
  userId,
  language,
  enabled,
}: TranslationQueryParams) => {
  return useQuery<TranslationData, Error>(
    videoKeys.translation(videoId, userId, language),
    () => getTranslationInfo(videoId, userId, language),
    {
      enabled,
      cacheTime: 0,
      staleTime: 0,
    }
  );
};
